import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import FolderRoundedIcon from '@mui/icons-material/FolderRounded';
import { Project } from '../../types';
import SkillChips from './SkillChips';

const ProjectCard: React.FC<{ project: Project }> = ({ project }) => {
    const theme = useTheme();
    const dark = theme.palette.mode === 'dark';

    return (
        <Box sx={{ p: 2.5, borderRadius: '14px', bgcolor: dark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)', border: `1px solid ${theme.palette.divider}` }}>
            <Stack direction="row" alignItems="flex-start" spacing={1.5} sx={{ mb: 1.5 }}>
                <FolderRoundedIcon sx={{ color: 'primary.main', fontSize: 20, mt: 0.3 }} />
                <Box sx={{ flex: 1 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: '0.95rem' }}>{project.name}</Typography>
                    <Chip label={project.role} size="small" sx={{ mt: 0.5, height: 22, fontSize: '0.7rem', fontWeight: 600, bgcolor: dark ? 'rgba(167,139,250,0.1)' : 'rgba(124,58,237,0.06)', color: dark ? '#C4B5FD' : '#7C3AED' }} />
                </Box>
            </Stack>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5, lineHeight: 1.6 }}>{project.description}</Typography>
            {project.achievements && project.achievements.length > 0 && (
                <Box sx={{ mb: 1.5 }}>
                    {project.achievements.map((a, i) => (
                        <Typography key={i} variant="body2" color="text.secondary" sx={{ pl: 2, position: 'relative', mb: 0.5, fontSize: '0.8rem', '&::before': { content: '"✓"', position: 'absolute', left: 0, color: 'primary.main', fontWeight: 700 } }}>
                            {a}
                        </Typography>
                    ))}
                </Box>
            )}
            <SkillChips skills={project.technologies} />
        </Box>
    );
};

export default ProjectCard;
